import React, { useMemo } from "react";
import "./Button.scss";
import { ReactSVG } from "react-svg";
import classNames from "classnames";
import {
    DEFAULT_SIZE_BUTTON,
    MAIN_BUTTON,
    SECONDARY_BUTTON,
    SMALL_SIZE_BUTTON,
} from "@constants";

const Button = ({
    text,
    handleClick,
    svgPath,
    type,
    size,
    isActive,
    isDisabled,
    blogMobile,
    className,
}) => {
    const buttonClassName = classNames("button", {
        "main-button": type === MAIN_BUTTON,
        "secondary-button--default":
            type === SECONDARY_BUTTON && size === DEFAULT_SIZE_BUTTON,
        "secondary-button--small":
            type === SECONDARY_BUTTON && size === SMALL_SIZE_BUTTON,
        "blog-mobile": blogMobile,
        [className]: !!className,
        isActive,
        disabled: isDisabled,
    });

    const button = useMemo(
        () =>
            isDisabled ? (
                <button className={buttonClassName} disabled type="button">
                    {text}
                    <ReactSVG
                        src={svgPath}
                        className="button__icon"
                        alt="button icon"
                    />
                </button>
            ) : (
                <button
                    className={buttonClassName}
                    onClick={handleClick}
                    type="button"
                >
                    {text}
                    {svgPath && (
                        <ReactSVG
                            src={svgPath}
                            className="button__icon"
                            alt="button icon"
                        />
                    )}
                </button>
            ),
        [isDisabled, buttonClassName, isActive, text, handleClick]
    );

    return button;
};

Button.defaultProps = {
    text: "",
    svgPath: "",
    type: MAIN_BUTTON,
    isDisabled: false,
};

export default Button;
